import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AuditChatMessage } from './audit-chat-api.service';
import { AuditChatMessageEntryComponent } from './audit-chat-message-entry.component';

@Component({
  selector: `ct-shared-chat-display`,
  template: `
    <div class="flex items-center gap-3">
      <strong class="text-lg">Chat</strong>
      <span class="bg-theme-red-500 rounded-full px-2 py-0.5 text-sm text-white"
        >{{ messages().length }} Nachrichten</span
      >
      <button class="mr-5 ml-auto p-2" (click)="closePopup.emit()">
        <img src="@shared/close.svg" class="brightness-50" />
      </button>
    </div>
    <div class="flex grow basis-[content] flex-col gap-3 overflow-auto">
      @for (message of messages(); track message.id) {
        <ct-shared-audit-chat-message-entry [message]="message" />
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AuditChatMessageEntryComponent],
})
export class AuditChatPopupDisplayComponent {
  readonly messages = input.required<AuditChatMessage[]>();

  closePopup = output();
}
